export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9395.ffc04ca5.jpg";